export default function sort(property: string) {
  const sort_order = -1;

  return (a: never, b: never) => {
    const date1 = new Date(a[property]);
    const date2 = new Date(b[property]);

    if (date1 < date2) {
      return -1 * sort_order;
    }
    if (date1 > date2) {
      return 1 * sort_order;
    }
    return 0 * sort_order;
  };
}
